// This matches our per_page limit default on the backend statements view
export const DOCUMENTS_PER_PAGE = 15;
